export const directivePrefix = 'wp';
